export default function Footer() {
    return (
        <div style={{ backgroundColor: "#F5F2EB" }}>
            <footer className="container py-4 mt-5">
                <div className='row text-dark'>
                    <div className='col-lg-9 col-xs-9 text-start'>
                        <p>© Copyright {new Date().getFullYear()}</p>
                    </div>
                </div>
            </footer>
        </div>
    )
}